/**
 * @generated SignedSource<<f4886e3f8f28f8e00a5d43cc786dafd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BulkTransfer_receipt$data = {
  readonly transactionFee: {
    readonly symbol: string;
    readonly unit: string;
    readonly usd: string;
  };
  readonly " $fragmentType": "BulkTransfer_receipt";
};
export type BulkTransfer_receipt$key = {
  readonly " $data"?: BulkTransfer_receipt$data;
  readonly " $fragmentSpreads": FragmentRefs<"BulkTransfer_receipt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BulkTransfer_receipt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceType",
      "kind": "LinkedField",
      "name": "transactionFee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usd",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionReceiptType",
  "abstractKey": null
};

(node as any).hash = "82ccff11873baa996d25a4acabfa240e";

export default node;
